import { Controller } from "stimulus";

export default class extends Controller {
  disable(e) {
    e.target.classList.add("disable");
  }
}
